module.exports = "/_next/static/images/energy-laptop-9892781f62b3e65d8ce53cb6d0508e73.png";